import { ReactNode } from 'react';

export function SlideIterator({ children }: { children: ReactNode }) {
    return (
        <div
            className="Iterator"
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                position: 'relative',
                height: '100%',
            }}
        >
            {children}
        </div>
    )
}
